import { createFileRoute } from "@tanstack/react-router";
import { requireReachableRoute } from "@/lib/offline/routeGuard";

// Section layout guard: settings (establishments admin, AI keys, platform
// plan/billing) is online-only by design. Covers every child route via
// ancestor stance resolution.
export const Route = createFileRoute("/_auth/app/_app/org/$orgId/settings")({
	staticData: { offline: "online-only" },
	beforeLoad: () => requireReachableRoute("online-only"),
});
